/* istanbul ignore file */

export const SITE_PAGE_CONSTANTS = {
    EMAIL_RENDERER_ERROR_MESSAGE: 'Enter a valid email',
    READ_ONLY_FIELD_SUPPORTING_TEXT: 'This field is read-only.',
    SUMMARY_PROJECT_READ_ONLY_TOOLTIP: 'This field is read-only in a summary project.',
    DELETE_ROW_NO_CHILDREN: 'Are you sure you want to delete this row? This action cannot be undone.',
    DELETE_ROW_WITH_CHILDREN: 'Deleting this parent row will also remove all associated sub-rows. This action cannot be undone.',
    DELETE_ROW_TITLE: 'Delete row?',
    DELETE_ROW_WITH_CHILDREN_TITLE: 'Delete parent row and sub-rows?',
};
